import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import { ThemeContext } from '@hig/theme-context';
import { CheckmarkXsUI, OperatorMinusXsUI } from '@hig/icons';
import { ControlBehavior } from '@hig/behaviors';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function getCheckboxRulesByFocus(themeData) {
  return {
    borderColor: themeData["checkbox.unchecked.focus.borderColor"],
    boxShadow: "0 0 0 " + themeData["checkbox.focus.haloWidth"] + "\n      " + themeData["checkbox.focus.haloColor"]
  };
}

function getCheckboxRulesByHover(themeData) {
  return {
    borderColor: themeData["checkbox.unchecked.default.borderColor"],
    boxShadow: "0 0 0 " + themeData["checkbox.hover.haloWidth"] + " " + themeData["checkbox.hover.haloColor"]
  };
}

function getCheckboxRulesByPressed(themeData) {
  return {
    borderColor: themeData["checkbox.unchecked.default.borderColor"],
    boxShadow: "0 0 0 " + themeData["checkbox.pressed.haloWidth"] + " " + themeData["checkbox.pressed.haloColor"]
  };
}

function getCheckboxRulesByDisabled(themeData) {
  return {
    opacity: themeData["colorScheme.opacity.disabled"],
    boxShadow: "none",
    pointerEvents: "none"
  };
}

function getCheckboxRulesByChecked(themeData) {
  return {
    border: "none",
    backgroundColor: themeData["checkbox.checked.default.backgroundColor"]
  };
}

function getCheckboxRulesByIndeterminate(themeData) {
  return {
    border: "none",
    backgroundColor: themeData["checkbox.checked.default.backgroundColor"]
  };
}

function stylesheet(props, themeData) {
  var checked = props.checked,
      disabled = props.disabled,
      hasFocus = props.hasFocus,
      hasHover = props.hasHover,
      indeterminate = props.indeterminate,
      isPressed = props.isPressed;


  return {
    checkboxWrapper: {
      boxSizing: "border-box",
      display: "inline-block",
      position: "relative",
      height: themeData["checkbox.minHeight"],
      width: themeData["checkbox.minWidth"]
    },
    checkboxCheckWrapper: _extends({
      position: "relative",
      display: "block",
      boxSizing: "border-box",
      color: "transparent",
      border: themeData["checkbox.borderWidth"] + " solid\n        " + themeData["checkbox.unchecked.default.borderColor"],
      backgroundColor: "transparent",
      textAlign: "center",
      fontSize: "25px",
      lineHeight: "14px",
      height: themeData["checkbox.minHeight"],
      width: themeData["checkbox.minWidth"],
      borderRadius: themeData["checkbox.borderRadius"],
      cursor: hasHover ? "pointer" : "default",
      transitionDuration: "0.3s, 0.3s",
      transitionProperty: "box-shadow, border",
      transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1)",
      // eslint-disable-next-line prettier/prettier
      "svg": {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        pointerEvents: "none",
        "*": {
          fill: themeData["checkbox.indicatorColor"]
        }
      }
    }, hasFocus ? getCheckboxRulesByFocus(themeData) : {}, hasHover ? getCheckboxRulesByHover(themeData) : {}, isPressed ? getCheckboxRulesByPressed(themeData) : {}, disabled ? getCheckboxRulesByDisabled(themeData) : {}, checked ? getCheckboxRulesByChecked(themeData) : {}, indeterminate ? getCheckboxRulesByIndeterminate(themeData) : {}),
    checkboxInput: {
      opacity: 0,
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      zIndex: 1,
      padding: 0,
      margin: 0
    },
    checkboxCheck: {
      display: checked && !indeterminate ? "block" : "none"
    },
    checkboxIndeterminate: {
      display: indeterminate ? "block" : "none"
    }
  };
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckPresenter = function (_Component) {
  _inherits(CheckPresenter, _Component);

  function CheckPresenter() {
    _classCallCheck(this, CheckPresenter);

    return _possibleConstructorReturn(this, (CheckPresenter.__proto__ || Object.getPrototypeOf(CheckPresenter)).apply(this, arguments));
  }

  _createClass(CheckPresenter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          hasFocus = _props.hasFocus,
          hasHover = _props.hasHover,
          indeterminate = _props.indeterminate,
          isPressed = _props.isPressed;


      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref) {
          var resolvedRoles = _ref.resolvedRoles;

          var styles = stylesheet({ checked: checked, disabled: disabled, hasFocus: hasFocus, hasHover: hasHover, indeterminate: indeterminate, isPressed: isPressed }, resolvedRoles);

          return React.createElement(
            "span",
            { className: css(styles.checkboxCheckWrapper) },
            React.createElement(
              "span",
              { className: css(styles.checkboxCheck) },
              React.createElement(CheckmarkXsUI, null)
            ),
            React.createElement(
              "span",
              { className: css(styles.checkboxIndeterminate) },
              React.createElement(OperatorMinusXsUI, null)
            )
          );
        }
      );
    }
  }]);

  return CheckPresenter;
}(Component);

CheckPresenter.propTypes = {
  /**
   * Checks the checkbox
   */
  checked: PropTypes.bool,
  /**
   * Prevents user actions on the checkbox
   */
  disabled: PropTypes.bool,
  /**
   * Returns whether or not the checkbox is currently focused
   */
  hasFocus: PropTypes.bool,
  /**
   * Returns whether or not the checkbox is currently hovered
   */
  hasHover: PropTypes.bool,
  /**
   * Returns whether or not the checkbox is currently pressed
   */
  isPressed: PropTypes.bool,
  /**
   * Sets indeterminate state for checkbox
   */
  indeterminate: PropTypes.bool
};
CheckPresenter.defaultProps = {
  checked: false,
  disabled: false,
  indeterminate: false
};
CheckPresenter.__docgenInfo = {
  "description": "",
  "displayName": "CheckPresenter",
  "props": {
    "checked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Checks the checkbox",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Prevents user actions on the checkbox",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "hasFocus": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Returns whether or not the checkbox is currently focused"
    },
    "hasHover": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Returns whether or not the checkbox is currently hovered"
    },
    "isPressed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Returns whether or not the checkbox is currently pressed"
    },
    "indeterminate": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Sets indeterminate state for checkbox",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    }
  }
};

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxPresenter = function (_Component) {
  _inherits$1(CheckboxPresenter, _Component);

  function CheckboxPresenter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1(this, CheckboxPresenter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = CheckboxPresenter.__proto__ || Object.getPrototypeOf(CheckboxPresenter)).call.apply(_ref, [this].concat(args))), _this), _this.setIndeterminate = function (input) {
      if (input) {
        // Workaround for https://github.com/facebook/react/issues/1798
        // eslint-disable-next-line no-param-reassign
        input.indeterminate = _this.props.indeterminate;
      }
    }, _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$1(CheckboxPresenter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          hasFocus = _props.hasFocus,
          hasHover = _props.hasHover,
          indeterminate = _props.indeterminate,
          isPressed = _props.isPressed,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onFocus = _props.onFocus,
          otherProps = _objectWithoutProperties(_props, ["checked", "disabled", "hasFocus", "hasHover", "indeterminate", "isPressed", "onBlur", "onChange", "onClick", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseUp", "onFocus"]);

      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref2) {
          var resolvedRoles = _ref2.resolvedRoles;

          var styles = stylesheet({
            checked: checked,
            disabled: disabled,
            hasFocus: hasFocus,
            hasHover: hasHover,
            indeterminate: indeterminate,
            isPressed: isPressed
          }, resolvedRoles);

          return React.createElement(
            "div",
            { className: css(styles.checkboxWrapper) },
            React.createElement("input", _extends$1({
              checked: checked,
              className: css(styles.checkboxInput),
              disabled: disabled,
              onBlur: onBlur,
              onChange: onChange,
              onClick: onClick,
              onFocus: onFocus,
              onMouseDown: onMouseDown,
              onMouseEnter: onMouseEnter,
              onMouseLeave: onMouseLeave,
              onMouseUp: onMouseUp,
              ref: _this2.setIndeterminate,
              type: "checkbox"
            }, otherProps)),
            React.createElement(CheckPresenter, {
              checked: checked,
              disabled: disabled,
              hasFocus: hasFocus,
              hasHover: hasHover,
              indeterminate: indeterminate,
              isPressed: isPressed
            })
          );
        }
      );
    }
  }]);

  return CheckboxPresenter;
}(Component);

CheckboxPresenter.propTypes = {
  /**
   * Checks the checkbox
   */
  checked: PropTypes.bool,
  /**
   * Prevents user actions on the checkbox
   */
  disabled: PropTypes.bool,
  /**
   * Returns whether or not the checkbox is currently focused
   */
  hasFocus: PropTypes.bool,
  /**
   * Returns whether or not the checkbox is currently hovered
   */
  hasHover: PropTypes.bool,
  /**
   * Sets indeterminate state for checkbox
   */
  indeterminate: PropTypes.bool,
  /**
   * Returns whether or not the checkbox is currently pressed
   */
  isPressed: PropTypes.bool,
  /**
   * The name of the checkbox as submitted with a form
   */
  name: PropTypes.string,
  /**
   * Called when user moves focus from the field
   */
  onBlur: PropTypes.func,
  /**
   * Called when the checkbox is changed
   */
  onChange: PropTypes.func,
  /**
   * Called when user clicks on the checkbox
   */
  onClick: PropTypes.func,
  /**
   * Called when user puts focus on the field
   */
  onFocus: PropTypes.func,
  /**
   * Triggers when the user's mouse is pressed over the checkbox
   */
  onMouseDown: PropTypes.func,
  /**
   * Triggers when the user's mouse is over the checkbox
   */
  onMouseEnter: PropTypes.func,
  /**
   * Triggers when the user's mouse is no longer over the checkbox
   */
  onMouseLeave: PropTypes.func,
  /**
   * Triggers when the user's mouse is no longer pressed over the checkbox
   */
  onMouseUp: PropTypes.func,
  /**
   * Value submitted with a form if checked
   */
  value: PropTypes.string
};
CheckboxPresenter.defaultProps = {
  checked: false,
  disabled: false,
  indeterminate: false,
  name: "checkbox",
  value: "value"
};
CheckboxPresenter.__docgenInfo = {
  "description": "",
  "displayName": "CheckboxPresenter",
  "props": {
    "checked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Checks the checkbox",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Prevents user actions on the checkbox",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "hasFocus": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Returns whether or not the checkbox is currently focused"
    },
    "hasHover": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Returns whether or not the checkbox is currently hovered"
    },
    "indeterminate": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Sets indeterminate state for checkbox",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "isPressed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Returns whether or not the checkbox is currently pressed"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The name of the checkbox as submitted with a form",
      "defaultValue": {
        "value": "\"checkbox\"",
        "computed": false
      }
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user moves focus from the field"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when the checkbox is changed"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user clicks on the checkbox"
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user puts focus on the field"
    },
    "onMouseDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is pressed over the checkbox"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is over the checkbox"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is no longer over the checkbox"
    },
    "onMouseUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is no longer pressed over the checkbox"
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Value submitted with a form if checked",
      "defaultValue": {
        "value": "\"value\"",
        "computed": false
      }
    }
  }
};

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {Object} State
 * @property {boolean} checked
 */

var CheckboxBehavior = function (_Component) {
  _inherits$2(CheckboxBehavior, _Component);

  function CheckboxBehavior() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$2(this, CheckboxBehavior);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = CheckboxBehavior.__proto__ || Object.getPrototypeOf(CheckboxBehavior)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checked: _this.props.defaultChecked
    }, _this.handleChange = function (event) {
      _this.setChecked(event.target.checked);
    }, _temp), _possibleConstructorReturn$2(_this, _ret);
  }

  /**
   * @type {State}
   */


  _createClass$2(CheckboxBehavior, [{
    key: "getChecked",


    /**
     * @returns {boolean}
     */
    value: function getChecked() {
      if (this.isControlled()) {
        return this.props.checked;
      }

      return this.state.checked;
    }

    /**
     * @param {boolean} checked
     */

  }, {
    key: "setChecked",
    value: function setChecked(checked) {
      var onChange = this.props.onChange;


      if (onChange) onChange(checked);

      if (!this.isControlled()) {
        this.setState({ checked: checked });
      }
    }
  }, {
    key: "isControlled",
    value: function isControlled() {
      return this.props.checked !== undefined;
    }

    /**
     * @param {UIEvent} event
     */

  }, {
    key: "render",
    value: function render() {
      var handleChange = this.handleChange;
      var handleClick = this.props.onClick;

      var checked = this.getChecked();

      return this.props.children({
        checked: checked,
        handleChange: handleChange,
        handleClick: handleClick
      });
    }
  }]);

  return CheckboxBehavior;
}(Component);

CheckboxBehavior.propTypes = {
  /**
   * Checks the checkbox
   */
  checked: PropTypes.bool,
  /**
   * Initially checks the checkbox, but allows user action to change it
   */
  defaultChecked: PropTypes.bool,
  /**
   * Called when user clicks on the field
   */
  onClick: PropTypes.func,
  /**
   * Called when user changes the value of the field
   */
  onChange: PropTypes.func,
  /**
   * Render prop
   */
  children: PropTypes.func
};
CheckboxBehavior.defaultProps = {
  defaultChecked: false
};
CheckboxBehavior.__docgenInfo = {
  "description": "@typedef {Object} State\n@property {boolean} checked",
  "displayName": "CheckboxBehavior",
  "props": {
    "checked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Checks the checkbox"
    },
    "defaultChecked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Initially checks the checkbox, but allows user action to change it",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user clicks on the field"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user changes the value of the field"
    },
    "children": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Render prop"
    }
  }
};

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
  _inherits$3(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck$3(this, Checkbox);

    return _possibleConstructorReturn$3(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass$3(Checkbox, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          controlledChecked = _props.checked,
          defaultChecked = _props.defaultChecked,
          disabled = _props.disabled,
          indeterminate = _props.indeterminate,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClick = _props.onClick,
          onFocus = _props.onFocus,
          onMouseDown = _props.onMouseDown,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          otherProps = _objectWithoutProperties$1(_props, ["checked", "defaultChecked", "disabled", "indeterminate", "onBlur", "onChange", "onClick", "onFocus", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseUp"]);

      return React.createElement(
        ControlBehavior,
        {
          onBlur: onBlur,
          onFocus: onFocus,
          onMouseDown: onMouseDown,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          onMouseUp: onMouseUp
        },
        function (_ref) {
          var hasFocus = _ref.hasFocus,
              hasHover = _ref.hasHover,
              isPressed = _ref.isPressed,
              handleBlur = _ref.onBlur,
              handleFocus = _ref.onFocus,
              handleMouseDown = _ref.onMouseDown,
              handleMouseEnter = _ref.onMouseEnter,
              handleMouseLeave = _ref.onMouseLeave,
              handleMouseUp = _ref.onMouseUp;
          return React.createElement(
            CheckboxBehavior,
            {
              checked: controlledChecked,
              defaultChecked: defaultChecked,
              onChange: onChange,
              onClick: onClick
            },
            function (_ref2) {
              var checked = _ref2.checked,
                  handleChange = _ref2.handleChange,
                  handleClick = _ref2.handleClick;
              return React.createElement(CheckboxPresenter, _extends$2({
                checked: checked,
                disabled: disabled,
                hasFocus: hasFocus,
                hasHover: hasHover,
                indeterminate: indeterminate,
                isPressed: isPressed,
                onBlur: handleBlur,
                onChange: handleChange,
                onClick: handleClick,
                onFocus: handleFocus,
                onMouseDown: handleMouseDown,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onMouseUp: handleMouseUp
              }, otherProps));
            }
          );
        }
      );
    }
  }]);

  return Checkbox;
}(Component);

Checkbox.propTypes = {
  /**
   * Checks the checkbox
   */
  checked: PropTypes.bool,
  /**
   * Initially checks the checkbox, but allows user action to change it
   */
  defaultChecked: PropTypes.bool,
  /**
   * Prevents user actions on the checkbox
   */
  disabled: PropTypes.bool,
  /**
   * Sets indeterminate state for checkbox
   */
  indeterminate: PropTypes.bool,
  /**
   * The name of the checkbox as submitted with a form
   */
  name: PropTypes.string,
  /**
   * Called when user moves focus from the field
   */
  onBlur: PropTypes.func,
  /**
   * Called when user changes the value of the field
   */
  onChange: PropTypes.func,
  /**
   * Called when user clicks on the checkbox
   */
  onClick: PropTypes.func,
  /**
   * Called when user puts focus on the field
   */
  onFocus: PropTypes.func,
  /**
   * Triggers when the user's mouse is pressed over the checkbox
   */
  onMouseDown: PropTypes.func,
  /**
   * Triggers when the user's mouse is over the checkbox
   */
  onMouseEnter: PropTypes.func,
  /**
   * Triggers when the user's mouse is no longer over the checkbox
   */
  onMouseLeave: PropTypes.func,
  /**
   * Triggers when the user's mouse is no longer pressed over the checkbox
   */
  onMouseUp: PropTypes.func,
  /**
   * Value submitted with a form if checked
   */
  value: PropTypes.string
};
Checkbox.__docgenInfo = {
  "description": "",
  "displayName": "Checkbox",
  "props": {
    "checked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Checks the checkbox"
    },
    "defaultChecked": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Initially checks the checkbox, but allows user action to change it"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Prevents user actions on the checkbox"
    },
    "indeterminate": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Sets indeterminate state for checkbox"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The name of the checkbox as submitted with a form"
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user moves focus from the field"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user changes the value of the field"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user clicks on the checkbox"
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user puts focus on the field"
    },
    "onMouseDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is pressed over the checkbox"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is over the checkbox"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is no longer over the checkbox"
    },
    "onMouseUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is no longer pressed over the checkbox"
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Value submitted with a form if checked"
    }
  }
};

export default Checkbox;
export { CheckboxBehavior };
